import React from "react";
import { AlertTriangle, GitMerge, X } from "lucide-react";

export default function PhoneDuplicateNudge({ candidates, onMerge, onDismiss }) {
  const first = candidates[0];
  const others = candidates.length - 1;
  return (
    <div
      data-testid="client-phone-duplicate-nudge"
      className="flex flex-col sm:flex-row sm:items-center gap-3 bg-amber-500/10 border border-amber-500/30 rounded-xl p-3.5"
    >
      <AlertTriangle size={18} className="text-amber-400 flex-shrink-0" />
      <div className="flex-1 min-w-0 text-sm">
        <p className="text-amber-200 font-semibold">Ce téléphone est déjà utilisé par un autre client</p>
        <p data-testid="client-phone-duplicate-nudge-target" className="text-white/60 text-xs mt-0.5 truncate">
          {first.client_name || "Sans nom"} · {first.client_email}
          {others > 0 ? ` · +${others} autre(s)` : ""}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onMerge}
          data-testid="client-phone-duplicate-merge-btn"
          className="inline-flex items-center gap-1.5 bg-amber-500 hover:bg-amber-600 text-black text-xs font-bold uppercase tracking-wider px-3 py-2 rounded transition-colors"
        >
          <GitMerge size={13} /> Fusionner maintenant
        </button>
        <button
          onClick={onDismiss}
          data-testid="client-phone-duplicate-dismiss-btn"
          title="Ignorer"
          className="p-2 rounded bg-white/5 hover:bg-white/10 text-white/60 transition-colors"
        >
          <X size={13} />
        </button>
      </div>
    </div>
  );
}
